<template>
    <li class="slm-event-list__item">
        <div v-if="event.status" class="slm-event-list__item-status-wrapper">
            <p class="slm-event-list__item-status-text">
                {{event.status}}
            </p>
        </div>
        <a class="slm-event-list__item-link" :href="event.url">
            <div class="slm-event-list__item-image-wrapper" 
                v-html="event.image ? event.image : (fallbackImage ? fallbackImage : '')"
            >
            </div>
            <div class="slm-event-list__item-info">
                <p class="slm-event-list__item-info--title">
                    {{event.title}}
                </p>
                <p class="slm-event-list__item-info--types">
                    {{eventTypes}}
                </p>
                <p class="slm-event-list__item-info--date">
                    {{event.startDate + ' - ' + event.endDate}}
                </p>
            </div>
        </a>
        <a v-if="event.subscribeUrl" class="slm-event-list__item-link--subscribe" :href="event.subscribeUrl" target="_blank">
            <span class="slm-event-list__item-link--subscribe-text">Påminn mig</span>
        </a>
    </li>
</template>

<script>
export default {
    name: 'event-component',
    props: ['event'],
    computed: {
        eventTypes() {
            const filters = this.event.isPast ? this.$store.getters.past.filters.options : this.$store.getters.upcoming.filters.options;
            const eventTypes = this.event.eventTypes && this.event.eventTypes.map(type => {
                return filters.find(filter => filter.value === type).title
            })
            return eventTypes.join(', ')
        },
        fallbackImage() {
            return this.$store.getters.fallbackImage;
        }
    }
}
</script>
